/**
 * Canonical Motzu category slugs for Shopify product_type mapping (batch UI + fallback).
 * Keep slug list in sync with `src/constants/motzuStoreCategorySlugs.ts` in the API repo.
 */
export const MOTZU_STORE_CATEGORY_SLUGS: string[] = [
  'mirrorless',
  'mirrorless-full-frame',
  'mirrorless-aps-c',
  'dslr',
  'compact',
  'point-and-shoot',
  'action-camera',
  'medium-format',
  'instant',
  'film',
  'video',
  'lenses',
  'prime',
  'zoom',
  'prime-wide-angle',
  'prime-telephoto',
  'prime-macro',
  'zoom-telephoto',
  'zoom-standard',
  'speedlight',
  'flash-and-lighting',
  'tripod',
  'tripods-and-support',
  'bag',
  'bags-and-cases',
  'battery',
  'batteries-and-power',
  'memory-and-storage',
  'filters',
  'microphone',
  'drones',
  'monitor',
  'cable',
  'strap',
  'clamp',
  'rail',
  'arm',
  'binocular',
  'cleaning',
];
